import React from 'react';

import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { CollectionsResourceQuery } from '~src/Collections/ResourceQuery/CollectionsResourceQuery';
import { CollectionCard } from '~src/Collections/space/CollectionCard';
import { ConnectedCollectionDetailsDialogBody } from '~src/Collections/space/CollectionDetailsDialog';
import { ICollectionInfo } from '~src/Collections/space/ICollectionInfo';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { ContentTypeFilterClause,ExplorableItemDefinition, MixedContentItemDefinition, SpaceDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { getNoDefaultFilters } from '~src/spacesPlatform/contentDefinitions/getDefaultFilters';
import { ContentFiltersKeys } from '~src/spacesPlatform/models/ContentFilters';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

export const CollectionDefinition: SpaceDefinition<'collection'> & ExplorableItemDefinition & MixedContentItemDefinition = {
  itemType: 'collection',
  singularName: Messages.collection,
  pluralName: Messages.collections,
  emptyStateMessage: Messages.collectionsEmptyMessage,
  contentFilterKeys: [
    ContentFiltersKeys.search,
    ContentFiltersKeys.owner,
    ContentFiltersKeys.updatedTimeAfter,
    ContentFiltersKeys.updatedTimeBefore,
    ContentFiltersKeys.createdTimeAfter,
    ContentFiltersKeys.createdTimeBefore,
    ContentFiltersKeys.favorite,
    ContentFiltersKeys.hideEmptyCollections,
    ContentFiltersKeys.collectionVisibility
  ],
  defaultFilters: getNoDefaultFilters,
  cardComponent: CollectionCard,
  listViewIconUrl: imgPath('collection_18px-large.svg'),
  filterClause: ServerFilterClauses.ContentType(['collection']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return new CollectionsResourceQuery();
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list', 'thumbnail'],
  contentType: 'collection',
  fieldValueResourceType: 'collection',
  contentSpaceUrl: (urls, _contentId, luid) => urls.collectionUrl(luid),
  headerIconPath: () => undefined, // we don't want to show a header icon for collections
  detailDialogTitle: Messages.collectionsDetailsTitle,
  detailDialogBody: (content: IContentInfo<'collection'>) => {
    return <ConnectedCollectionDetailsDialogBody collection={content as ICollectionInfo}/>;
  },
  siteFilterByTypeDropdownName: Messages.collection
};
